<template>
  <div class="runs-box">
    <div class="d-flex justify-content-between">
      <div class="font-weight-bold">{{ 'Runs' | trans }}</div>
      <span class="badge badge-pro" @click="handleProOrChange(currentRun.name)" v-if="isLegacyUser === true">{{ 'PRO' | trans }}</span>
      <span class="badge badge-warning" @click="handleProOrChange(currentRun.name)" v-if="isLegacyUser === false">{{ 'PREMIUM' | trans }}</span>
    </div>
  <div>
      <p>
        {{ "The 'Runs' option allows you to select a specific runtime for the AI, influencing the duration of its thought process. Choosing a different runtime can impact the depth and complexity of the AI's considerations, potentially leading to varied results."| trans}}
      </p>
      <p>
        {{ "Experiment with runtimes to find the balance that suits your needs, understanding that longer runtimes may yield more nuanced responses, while shorter runtimes provide quicker results with potential trade-offs in depth." | trans}}
      </p>
  </div>
    <div class="runs-container">
      <div
          v-for="run in runs"
          :class="{ 'active': currentRun.name === run.name, 'disabled': (isFreeUser || (isLegacyUser === true && !isProAndAboveUser)) && currentRun.name !== run.name }"
          class="runs-btn"
          @click="handleProOrChange(run.name)"
      >
        {{ run.name | trans }}
        <div
            :class="{ 'active': currentRun.name === run.name}"
            class="checkmark-box"
        >
          <i class="fa fa-check"></i>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import RunsManager from "../../manager/RunsManager";
import user from './../../mixins/user.mixin';
import { EventBus } from '../../events/event.bus';
import { EVENT_PAYMENT_UNLOCK_PRO, EVENT_PAYMENT_UNLOCK_STARTER } from "../../events/payment.events";

export default {
  name: "Runs",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
    user
  ],
  data() {
    return {
      runs: []
    };
  },
  mounted: function () {

  },
  created: function () {
    this.runs = RunsManager.runs;
  },
  methods: {
    handleProOrChange(name) {
      if (this.isFreeUser || (this.isLegacyUser === true && !this.isProAndAboveUser)) {
        this.creatorStudio.settings.conversion.options.num_inference_steps = 20;

        EventBus.$emit(EVENT_PAYMENT_UNLOCK_PRO, {});
      } else {
        const run = RunsManager.getByName(name);
        this.creatorStudio.settings.conversion.options.num_inference_steps = run.value;
      }
    },
  },
  computed: {
    currentRun() {
      return RunsManager.getByValue(this.creatorStudio.settings.conversion.options.num_inference_steps);
    }
  }
};
</script>
<style lang="scss">
.runs-box {
  gap: 20px;
  display: flex;
  flex-direction: column;
}

.checkmark-box {
  color: white;
  background: #1266F1;
  border-radius: 50%;
  position: absolute;
  padding: 5px;
  width: 24px;
  height: 24px;
  right: -10px;
  top: -13px;
  justify-content: center;
  align-items: center;
  display: none;

  &.active {
    display: flex !important;
  }
}

.runs-container {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.runs-btn {
  cursor: pointer;
  border-radius: 9px;
  background: #383838;
  position: relative;
  display: flex;
  height: 48px;
  border: 3px solid transparent;
  gap: 10px;
  padding: 10px;
  align-items: center;

  &.active {
    border: 3px solid #1266F1;
  }

  &:hover {
    background: #323232;
  }
}
</style>
